import { useTranslation } from 'react-i18next';
import { findCurrentSupportedLanguageEntry } from '../../i18n';

import './Language.scss';

const LanguageBadge = () => {
  const { i18n } = useTranslation();
  const info = findCurrentSupportedLanguageEntry();

  return (
    <>
      {info && (
        <button className={`lang-badge ${i18n.language}`}>
          {info.flag} {info.locale.toUpperCase()}
        </button>
      )}
    </>
  );
};

export default LanguageBadge;
